import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from './error-message.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    ErrorMessageComponent
  ],
  exports: [
    ErrorMessageComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
  ]
})
export class ErrorMessageModule { }
